module.exports = __webpack_public_path__ + "img/delete_plot.e244b59d.png";